import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Auth.css';

export default class Auth extends Component {
  static propTypes = {
    token: PropTypes.str,
    push: PropTypes.func,
    redirect: PropTypes.str,
    setPayload: PropTypes.func
  }

  componentDidMount() {
    if(this.props.token) {
      window.localStorage.setItem('jwt', this.props.token)
      const { redirect = '/' } = this.props;
      this.props.setPayload(this.props.token)
      this.props.push(redirect);
    }
  }

  render() {
    return (
      <div>
        Authenticating
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AuthComponent/Auth.js